/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from '../feed/defs.defs'
import * as UnspeccedDefs from './defs.defs'

const $nsid = 'app.bsky.unspecced.getPostThreadV2'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  anchor: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  above: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), true),
  ),
  below: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 20 }),
      6,
    ),
  ),
  branchingFactor: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
      10,
    ),
  ),
  sort: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.string<{ knownValues: ['newest', 'oldest', 'top'] }>(),
      'oldest',
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  thread: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ThreadItem>((() => threadItem) as any),
  ),
  threadgate: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<FeedDefs.ThreadgateView>(
      (() => FeedDefs.threadgateView) as any,
    ),
  ),
  hasOtherReplies: /*#__PURE__*/ l.boolean(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** (NOTE: this endpoint is under development and WILL change without notice. Don't use it until it is moved out of `unspecced` or your application WILL break) Get posts in a thread. It is based in an anchor post at any depth of the tree, and returns posts above it (recursively resolving the parent, without further branching to their replies) and below it (recursive replies, with branching to their replies). Does not require auth, but additional metadata and filtering will be applied for authed requests. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type ThreadItem = {
  $type?: 'app.bsky.unspecced.getPostThreadV2#threadItem'
  uri: l.AtUriString

  /**
   * The nesting level of this item in the thread. Depth 0 means the anchor item. Items above have negative depths, items below have positive depths.
   */
  depth: number
  value:
    | l.$Typed<UnspeccedDefs.ThreadItemPost>
    | l.$Typed<UnspeccedDefs.ThreadItemNoUnauthenticated>
    | l.$Typed<UnspeccedDefs.ThreadItemNotFound>
    | l.$Typed<UnspeccedDefs.ThreadItemBlocked>
    | l.Unknown$TypedObject
}

export type { ThreadItem }

const threadItem = /*#__PURE__*/ l.typedObject<ThreadItem>(
  $nsid,
  'threadItem',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    depth: /*#__PURE__*/ l.integer(),
    value: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<UnspeccedDefs.ThreadItemPost>(
          (() => UnspeccedDefs.threadItemPost) as any,
        ),
        /*#__PURE__*/ l.typedRef<UnspeccedDefs.ThreadItemNoUnauthenticated>(
          (() => UnspeccedDefs.threadItemNoUnauthenticated) as any,
        ),
        /*#__PURE__*/ l.typedRef<UnspeccedDefs.ThreadItemNotFound>(
          (() => UnspeccedDefs.threadItemNotFound) as any,
        ),
        /*#__PURE__*/ l.typedRef<UnspeccedDefs.ThreadItemBlocked>(
          (() => UnspeccedDefs.threadItemBlocked) as any,
        ),
      ],
      false,
    ),
  }),
)

export { threadItem }
